import { DocumentLink } from 'src/front/api/apiInstance';
import { DocumentLinkParameterType } from 'src/front/api/generated';

export const getUserManual = async (): Promise<void> => {
  const { data } = await DocumentLink.getDocumentLinkByParameter({
    documentLinkParameterType: DocumentLinkParameterType.USERMANUAL,
  });
  if (data.result === 'OK' && data.documentLinkParameterDataList) {
    data.documentLinkParameterDataList.forEach((document) => {
      window.open(document.link);
    });
  }
};

export default getUserManual;
